import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  convertKeyToValue,
  getOptionsFromQuestionRaws,
  isDropdown,
  getTypeOfQuestion,
  formatStringToCurrency,
  filterPropertiesOfPolicyDetails
} from '@app/features/coverage/coverage';
@Component({
  selector: 'app-coverage-policy-details',
  templateUrl: './policy-details.component.html'
})

export class PolicyDetailsComponent {
  @Input() data: any;
  @Output() remove = new EventEmitter<any>();
  @Output() addMore = new EventEmitter<any>();

  // Functions
  convertKeyToValue: any;
  getOptionsFromQuestionRaws: any;
  isDropdown: any;
  getTypeOfQuestion: any;
  formatStringToCurrency: any;
  getPropertyNames: any;
  policyFiltered = {};

  constructor() {
    this.convertKeyToValue = convertKeyToValue;
    this.getOptionsFromQuestionRaws = getOptionsFromQuestionRaws;
    this.isDropdown = isDropdown;
    this.getTypeOfQuestion = getTypeOfQuestion;
    this.formatStringToCurrency = formatStringToCurrency;
    this.getPropertyNames = Object.keys;
  }

  onRemove() {
    this.remove.emit(this.data);
  }

  onAddMore() {
    this.addMore.emit();
  }

  getLabel(key: string) {
    let result;
    this.data.labels.filter(obj => {
      if (obj.key === key) {
        result = obj.value;
      }
    });

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/features/coverage/policy-details/policy-details.component.ts